import React from "react";
import { forceValidation } from "../../shared/validMeReact";
import { saveBooking, updateBooking } from "../../../actions/booking";
import {
  updateRecurringAppointmentConfirmationModalVisibility,
  updateMultiServiceAppointmentConfirmationModalVisibility
} from "../../../actions/menu";

export const saveAppointmentDataHandler = (
  dispatch,
  appointmentStepData,
  advancedAppointmentStepData,
  currentBookingId,
  advancedAppointmentStepDataFromLastSave,
  callback,
  forceSave,
  isMultiServiceAppointment,
  gotValidOffer,
  closeWhenSaved = false
) => {
  let { recurringToggleOn } = advancedAppointmentStepData;
  let cb = () => {
    if (callback) {
      callback();
    }
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "refresh"
      }
    });
    window.dispatchEvent(event);
  };
  let savedSnapshot = sessionStorage.getItem("BOOKING_APPOINTMENT_SNAPSHOT");
  let currentSnapshot = JSON.stringify({
    appointmentStepData,
    advancedAppointmentStepData
  });

  if (savedSnapshot == currentSnapshot && !forceSave) {
    //if there are no changes, no need to show the modal
    if (callback) {
      callback();
    }
  } else {
    if (
      currentBookingId &&
      advancedAppointmentStepDataFromLastSave.recurringToggleOn
    ) {
      let visibleRecursiveAppointmentModal = true;
      let closeAppWhenRecursiveAppointmentModalCloses = closeWhenSaved;
      dispatch(
        updateRecurringAppointmentConfirmationModalVisibility(
          visibleRecursiveAppointmentModal,
          closeAppWhenRecursiveAppointmentModalCloses
        )
      );
    } else if (
      currentBookingId &&
      isMultiServiceAppointment &&
      appointmentStepData.triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
    ) {
      let visibleMultiServiceAppointmentModal = true;
      let closeAppWhenMultiserviceModalCloses = closeWhenSaved;
      dispatch(
        updateMultiServiceAppointmentConfirmationModalVisibility(
          visibleMultiServiceAppointmentModal,
          closeAppWhenMultiserviceModalCloses
        )
      );
    } else if (currentBookingId) {
      dispatch(
        updateBooking(
          appointmentStepData,
          advancedAppointmentStepData,
          currentBookingId,
          null,
          null,
          cb,
          isMultiServiceAppointment,
          gotValidOffer
        )
      );
    } else {
      dispatch(
        saveBooking(
          appointmentStepData,
          advancedAppointmentStepData,
          null,
          null,
          cb,
          isMultiServiceAppointment,
          gotValidOffer
        )
      );
    }
  }
};
